import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

import SharingDialog from "Workspace/components/SharingDialog";
import { pushToast } from "containers/ToastManager/actions";
import { dispatch } from "pluginServices/store";
import { intl } from "containers/LanguageProvider/IntlGlobalProvider";
import knowledgeService from "services/KnowledgeService";
import messages from "./messages";

const KnowledgeMapCollaborators = ({ competencyDocument, theme }) => {
  const { id: documentId } = competencyDocument;
  const [collaborators, setCollaborators] = useState({});

  useEffect(() => {
    async function getCollaborators() {
      const response = await knowledgeService.getCollaboratorsList(
        documentId
      );
      if (response) {
        setCollaborators(response.collaborators);
      }
    }

    getCollaborators();
  }, [competencyDocument, documentId]);

  const handlePermissionGrant = async (
    accountOrTeamIds,
    collaboratorType,
    refId,
    permissionLevel
  ) => {
    const payLoad = {
      accountOrTeamIds,
      collaboratorType,
      refId,
      permissionLevel,
      documentId,
    };
    const grantPermissionResponse = await knowledgeService.grantCollaboratorPermission(
      payLoad
    );
    if (grantPermissionResponse) {
      const response = await knowledgeService.getCollaboratorsList(documentId);
      setCollaborators(response.collaborators);
    } else {
      const message = intl.formatMessage(messages.grantPermissionError);
      dispatch(pushToast({ message }));
    }
  };

  const handlePermissionRevoke = async (account) => {
    const payLoad = {
      accountOrTeamIds: account.id,
      collaboratorType: account.type,
      documentId,
    };
    const revokePermissionResponse = await knowledgeService.revokeCollaboratorPermission(
      payLoad
    );
    if (revokePermissionResponse) {
      const response = await knowledgeService.getCollaboratorsList(documentId);
      setCollaborators(response.collaborators);
    } else {
      const message = intl.formatMessage(messages.revokePermissionError);
      dispatch(pushToast({ message }));
    }
  };

  return (
    <SharingDialog
      avatarBorderColor={theme["color.surface"]}
      sharedWith={collaborators}
      refId={documentId}
      handleDelete={handlePermissionRevoke}
      grantPermissionNoStoreCallback={handlePermissionGrant}
    />
  );
};
KnowledgeMapCollaborators.propTypes = {
  competencyDocument: PropTypes.object,
  theme: PropTypes.object,
};
export default withTheme(KnowledgeMapCollaborators);
